import "../../styles/anim-loading.css";

export const AnimatedLoader = () => {
    return (
        <div className="full-cnt-pg blk-bg">
            <div className="loader">
                <span />
                <span />
                <span />
                <span />
                <span />
            </div>
        </div>
    );
}